import { render, staticRenderFns } from "./ShortcutWebpart.vue?vue&type=template&id=533d8979"
import script from "./ShortcutWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ShortcutWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports